import { defineMessages } from 'react-intl';

const enumMessages = defineMessages({
    '101': {
        id: 'transactionsFilterForm.cashPurchase',
        defaultMessage: 'Cash purchase',
    },
    '102': {
        id: 'transactionsFilterForm.internationalPurchase',
        defaultMessage: 'International purchase',
    },
    '111': {
        id: 'transactionsFilterForm.installmentWithoutInterest',
        defaultMessage: 'Installment without interest',
    },
    '112': {
        id: 'transactionsFilterForm.installmentWithoutInterest',
        defaultMessage: 'Installment without interest',
    },
    '121': {
        id: 'transactionsFilterForm.installmentWithInterest',
        defaultMessage: 'Installment with interest',
    },
    '122': {
        id: 'transactionsFilterForm.installmentWithInterest',
        defaultMessage: 'Installment with interest',
    },
    '123': {
        id: 'transactionsFilterForm.withdrawal',
        defaultMessage: 'Withdrawal',
    },
    '124': {
        id: 'transactionsFilterForm.internationalWithdrawal',
        defaultMessage: 'International withdrawal',
    },
    '131': {
        id: 'transactionsFilterForm.quasiCashPurchase',
        defaultMessage: 'Quasi-Cash purchase',
    },
    '201': {
        id: 'transactionsFilterForm.payment',
        defaultMessage: 'Payment',
    },
    asc: {
        id: 'transactionsFilterForm.asc',
        defaultMessage: 'Oldest to newest',
    },
    desc: {
        id: 'transactionsFilterForm.desc',
        defaultMessage: 'Newest to oldest',
    },
    PLATFORM: {
        id: 'transactionsFilterForm.platform',
        defaultMessage: 'Platform',
    },
    NETWORK: {
        id: 'transactionsFilterForm.network',
        defaultMessage: 'Network',
    },
});

export default enumMessages;
